<template>
  <div>
    <v-progress-circular v-if="!isAuthenticated" indeterminate color="primary"> </v-progress-circular>
    <v-navigation-drawer v-if="isAuthenticated" v-model="drawer" app clipped permanent :width="navWidth" @transitionend="collapseSubItems" color="primary">
      <v-card class="mx-auto">
        <v-card class="mx-auto">
          <v-list dense nav color="inverted">
            <v-list-group v-for="item in menu" :key="item.text" :prepend-icon="item.icon" v-model="item.active">
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title class="d-none d-md-block" v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="ml-4" v-for="subItem in item.subItems" :key="subItem.text" link :to="subItem.route">
                <v-list-item-icon>
                  <v-icon v-text="subItem.icon"></v-icon>
                </v-list-item-icon>

                <v-list-item-title class="d-none d-md-block" v-text="subItem.text"></v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-card>
    </v-navigation-drawer>

    <v-app-bar app clipped-left dense color="primary" dark>
      <v-btn to="/" icon>
        <v-icon medium>mdi-home</v-icon>
      </v-btn>

      <v-toolbar-title class="mr-12 align-center">
        <span class="title">eCloud Admin</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn v-if="isAuthenticated" @click="logout()" color="secondary">Logout</v-btn>

      <v-btn v-if="!isAuthenticated" to="/login" color="secondary" class="mr-2">Login</v-btn>
      <v-btn v-if="!isAuthenticated" to="/user/register" color="secondary">Register</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  import { tokenAuthenticator } from '../tokenAuthenticator';

  export default {
    name: 'NavBar',
    props: ['menu'],

    data: () => ({
      drawer: true,
      loading: true,
      authenticated: false,
    }),
    computed: {
      isAuthenticated() {
        return this.authenticated && !this.loading;
      },
      navWidth() {
        return this.$vuetify.breakpoint.smAndDown ? 80 : 340;
      },
    },
    apollo: {
      $client: 'authenticationClient',
    },
    methods: {
      async logout() {
        tokenAuthenticator.logout();
        this.authenticated = false;

        this.$router.push({ name: 'Login' });
      },
      collapseSubItems() {
        this.menu.map((item) => (item.active = false));
      },
    },
    async created() {
      this.$bus.$on('login', () => {
        this.authenticated = true;
      });

      this.$bus.$on('logout', () => {
        this.authenticated = false;
      });

      if (!tokenAuthenticator.getToken()) {
        let token = await tokenAuthenticator.updateToken();
        if (token) {
          this.authenticated = true;
        } else {
          this.authenticated = false;
        }

        this.loading = false;
      }
    },
  };
</script>
